function isObject (obj)
{
    return (typeof obj === 'object' && !Array.isArray(obj) && obj !== null && obj !== undefined)
}

function isEmpty (obj)
{
    for (var prop in obj)
    {
        if(obj.hasOwnProperty(prop)) return false;
    }

    return true;
}

function clone (obj)
{
    return JSON.parse(JSON.stringify(obj))
}

function getPropertyParent (prop, obj)
{
    const searchInChildren = (val, parent) =>
    {
        for (const [, value] of Object.entries(parent))
        {
            if (value == val) return parent
            if (isObject(value))
            {
                const inChild = searchInChildren(val, value)
                if (inChild) return inChild
            }
        }
    }

    return searchInChildren(prop, obj) || null
}

export default { isObject, isEmpty, clone, getPropertyParent }


// WEBPACK FOOTER //
// ./src/utils/objectUtils.js